import { makeVar } from '@apollo/client';
import { Cart } from 'types/cache/Cart';

export const cartVar = makeVar<Cart>({
  cartItems: [],
  price: { amount: 0, currency: '' },
  travelItineraryId: null,
});
